export const EMPLOYEE_TYPES = {
  MANAGER: 'manager',
  STORE_INCHARGE: 'store_incharge',
  DELIVERY_PERSON: 'delivery_person',
  DRIVER: 'driver',
};

const COMMON_ROUTES = ['update-profile'];

const MANAGER_ROUTES = [
  'add-package',
  'packages',
  'print-invoice',
  'scan-package',
  'scan-out-of-delivery',
  'delivered',
  'delivery-lists',
  'deliveries',
  'to-pays',
  'collections',
  'out-of-delivery-packages',
  'scanned-packages',
  'enquiries',
  ...COMMON_ROUTES,
];

const STORE_INCHARGE_ROUTES = ['scan-package', 'scanned-packages', ...COMMON_ROUTES];

const DELIVERY_PERSON_ROUTES = [
  'scan-out-of-delivery',
  'delivered',
  'delivery-lists',
  'out-of-delivery-packages',
  ...COMMON_ROUTES,
];

const ROUTES_BY_EMPLOYEE_TYPE = {
  [EMPLOYEE_TYPES.MANAGER]: MANAGER_ROUTES,
  [EMPLOYEE_TYPES.STORE_INCHARGE]: STORE_INCHARGE_ROUTES,
  [EMPLOYEE_TYPES.DELIVERY_PERSON]: DELIVERY_PERSON_ROUTES,
};

const DEFAULT_ROUTE_BY_EMPLOYEE_TYPE = {
  [EMPLOYEE_TYPES.MANAGER]: '/packages',
  [EMPLOYEE_TYPES.STORE_INCHARGE]: '/scan-package',
  [EMPLOYEE_TYPES.DELIVERY_PERSON]: '/scan-out-of-delivery',
};

export const getAuthContext = () => {
  const role = localStorage.getItem('role');
  const user = JSON.parse(localStorage.getItem('user') || 'null');
  const employeeType = user?.employeeType || '';

  return {
    role,
    user,
    employeeType,
    isAdmin: role === 'admin',
  };
};

const normalizeRoutePath = (path = '') => path.replace(/^\//, '').split('?')[0];

export const canAccessRoute = (path) => {
  const { isAdmin, employeeType } = getAuthContext();

  if (isAdmin) {
    return true;
  }

  const routePath = normalizeRoutePath(path);
  const allowedRoutes = ROUTES_BY_EMPLOYEE_TYPE[employeeType] || COMMON_ROUTES;

  return allowedRoutes.includes(routePath);
};

export const getDefaultRoute = () => {
  const { isAdmin, employeeType } = getAuthContext();
  if (isAdmin) {
    return '/dashboard-admin';
  }

  return DEFAULT_ROUTE_BY_EMPLOYEE_TYPE[employeeType] || '/update-profile';
};

export const filterNavConfig = (navConfig = []) =>
  navConfig
    .map((item) => {
      if (item.children?.length) {
        const filteredChildren = item.children.filter((child) => canAccessRoute(child.path));

        if (filteredChildren.length === 0) {
          return null;
        }

        return { ...item, children: filteredChildren };
      }

      if (!canAccessRoute(item.path)) {
        return null;
      }

      return item;
    })
    .filter(Boolean);
